module.exports = __webpack_public_path__ + "img/arrow-back.e1adcae9.svg";